import clsx from 'clsx';

import styles from './GlyphsCharacter.module.scss';

type TTags = 'div' | 'button';

interface IProps {
  char: string;
  entity: string;
  script?: string;
  subCategory?: string;
  glyphSheetName?: string;
  handler?: (char: string, script: string, subCategory: string) => void;
  as?: TTags;
  style?: React.CSSProperties;
  hoverEffect?: boolean;
  children?: React.ReactNode;
}

const GlyphsCharacter: React.FC<IProps> = ({
  char,
  entity,
  script,
  subCategory,
  glyphSheetName,
  handler,
  as = 'div',
  style,
  hoverEffect = true,
  children
}) => {
  const glyphContent = (
    <>
      <div className={styles.glyphChar__Entity}>{entity}</div>
      <div
        className={styles.glyphChar__Char}
        style={
          style
            ? style
            : {
                fontFamily: `var(--${glyphSheetName})`,
                color: `var(--black)`
              }
        }
      >
        {children || char}
      </div>
    </>
  );

  return (
    <div
      className={clsx(styles.glyphChar, {
        [styles.hoverEffect]: hoverEffect
      })}
    >
      {as === 'div' ? (
        <div>{glyphContent}</div>
      ) : (
        <button
          type="button"
          title="Open Glyph Modal for further detail"
          onClick={() => handler(char, script, subCategory)}
        >
          {glyphContent}
        </button>
      )}
    </div>
  );
};

export default GlyphsCharacter;
